import { t } from 'i18next';
import type { ActionDialogState } from './types';

export const initialActionDialogState: ActionDialogState = {
  isOpen: false,
  title: '',
  message: t('dialog.error.message', { ns: 'learners-experience' }),
  confirmText: t('dialog.error.confirm', { ns: 'learners-experience' })
};
